import { Email } from "@msuite/ui/link";
import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import { moment } from "@msuite/utils/date";
import { guardString } from "@msuite/utils/strings";
import type { IncomingEmailListItem } from "@msuite/utils/types";
import { IncomingEmailAttachments } from "./incoming-email-attachments";
import { IncomingEmailOutcomeTag } from "./incoming-email-outcome-tag";
import { IncomingEmailProcessingStateTag } from "./incoming-email-processing-state-tag";

const columnHelper = createColumnHelper<IncomingEmailListItem>();

export const columns = [
	columnHelper.accessor("receivedAt", {
		id: "receivedAt",
		header: localized("mailboxes.received_at"),
		cell: (cell) => moment(cell.getValue()).longFormat(),
	}),
	columnHelper.accessor((row) => row.fromName || row.fromAddress, {
		id: "from",
		header: localized("mailboxes.from"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("fromAddress", {
		id: "fromAddress",
		header: localized("mailboxes.from_email"),
		cell: (cell) => <Email>{guardString(cell.getValue())}</Email>,
	}),
	columnHelper.accessor("subject", {
		id: "subject",
		header: localized("mailboxes.subject"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("outcome", {
		id: "outcome",
		header: localized("mailboxes.health"),
		cell: (cell) => <IncomingEmailOutcomeTag outcome={cell.getValue()} />,
	}),
	columnHelper.accessor("processingState", {
		id: "processingState",
		header: localized("mailboxes.processing"),
		cell: (cell) => <IncomingEmailProcessingStateTag processingState={cell.getValue()} />,
	}),
	columnHelper.accessor((row) => row.attachments.length, {
		id: "attachments",
		header: localized("mailboxes.attachments"),
		cell: (cell) => <IncomingEmailAttachments attachments={cell.row.original.attachments} />,
	}),
	columnHelper.accessor("note", {
		id: "note",
		header: localized("mailboxes.note"),
		cell: (cell) => guardString(cell.getValue()),
	}),
];
